export default function(app) {
  app.component('partners', {template: require('./partners.html')});
}
